const arrayColumn = (array, column) => array.map(function(value) {
    return value[column];
})

const findIndexByColumnValue = (array, columnName, columnValue) => {

    let foundIndex = -1
    array.forEach((elem, index) => {

        if (Array.isArray(columnName)) {
            let equals = true
            for (let i in columnName) {
                if (elem[columnName[i]] != columnValue[i]) {
                    equals = false
                    return false
                }
            }

            if (equals) {
                foundIndex = index;
                return false
            }
        }

        else {
            if (elem && elem[columnName] == columnValue) {
                foundIndex = index;
                return false
            }
        }
    });

    return foundIndex
}

const findIndexByColumnValueInGroup = (array, groupName, columnName, columnValue) => {
    let foundIndex = -1

    array.forEach((group, index) => {
        group[groupName].forEach(elem => {
            if (elem[columnName] == columnValue) {
                foundIndex = index;
                return false
            }
        });
    });

    return foundIndex
}

const exists = (array, columnName, columnValue) => {
    let pos = findIndexByColumnValue(array, columnName, columnValue)
    return pos >= 0
}

const inArray = (array, item) => {
    return array.indexOf(item) >= 0
}

const cloneArray = (array) => {
    let newArray = null

    if (Array.isArray(array)) {
        newArray = []
        array.forEach(item => {
            if (typeof item === 'object' || Array.isArray(item)) {
                newArray.push(cloneArray(item))
            } else {
                newArray.push(item)
            }
        })
    }
    else if (typeof array === 'object') {
        newArray = {}

        for (let i in array) {
            newArray[i] = cloneArray(array[i])
            if (typeof array[i] === 'object' || Array.isArray(array[i])) {
                newArray[i] = cloneArray(array[i])
            }
            else {
                newArray[i] = array[i]
            }
        }
    }

    return newArray
}

const arrayDiff = (array1, array2, columnName = "") => {
    var newArray = []
    if (Array.isArray(array1)) {
        array1.forEach(item => {
            if (!exists(array2, columnName, item[columnName])) {
                newArray.push(item)
            }
        })
    }
    else {
        newArray = {}
        for (let i in array1) {
            if (array2.indexOf(i) < 0) {
                newArray[i] = array1[i]
            }
        }
    }

    return newArray
}

const addColumn = (array, columnName, columnValue) => {
    for (let i in array) {
        array[i][columnName] = columnValue
    }

    return array
}

export default {
    arrayColumn,
    findIndexByColumnValue,
    findIndexByColumnValueInGroup,
    exists,
    inArray,
    cloneArray,
    arrayDiff,
    addColumn,
}